import moment from 'moment';
import Xhr from 'utils/xhr';
import * as types from './action_types';

const API_URL = 'admins/eventlogs';

const normalizeFilter = (filter) => {
  const userId = (filter.userId || '').trim();
  const fromMoment = parseDate(filter.dateFrom);
  const toMoment = parseDate(filter.dateTo);

  if (!userId) {
    return { error: 'ユーザーIDを入力してください。' };
  }
  if (!fromMoment || !toMoment) {
    return { error: '日時（から）と日時（まで）を正しく入力してください。' };
  }
  if (!fromMoment.isBefore(toMoment)) {
    return {
      error: '日時（から）は日時（まで）より前の時刻を指定してください。',
    };
  }

  const normalizedFilter = {
    userId,
    dateFrom: fromMoment.format('YYYY-MM-DDTHH:mm'),
    dateTo: toMoment.format('YYYY-MM-DDTHH:mm'),
  };

  return {
    filter: normalizedFilter,
    params: buildParamsFromMoments(userId, fromMoment, toMoment),
  };
};

const parseDate = (value) => {
  if (!value) return null;
  const parsed = moment(value, moment.ISO_8601, true);
  if (parsed.isValid()) {
    return parsed.seconds(0).milliseconds(0);
  }
  const fallback = moment(value, 'YYYY-MM-DD HH:mm:ss', true);
  if (fallback.isValid()) {
    return fallback.seconds(0).milliseconds(0);
  }
  return null;
};

const buildParamsFromMoments = (userId, fromMoment, toMoment) => {
  return {
    user_id: userId,
    date_from: fromMoment.format('YYYY-MM-DD HH:mm:ss'),
    date_to: toMoment.format('YYYY-MM-DD HH:mm:ss'),
  };
};

const buildParamsFromFilter = (filter) => {
  const fromMoment = parseDate(filter.dateFrom);
  const toMoment = parseDate(filter.dateTo);
  if (!filter.userId || !fromMoment || !toMoment) return null;
  return buildParamsFromMoments(filter.userId, fromMoment, toMoment);
};

const fetchEventlogsInternal = ({
  after = null,
  history = [],
  params,
} = {}) => {
  return (dispatch, getState) => {
    const state = getState();
    const requestParams = params ||
      buildParamsFromFilter(state.filter) || {
        invalid: true,
      };

    if (requestParams.invalid) {
      dispatch(
        error([
          '検索条件が無効です。ユーザーIDと日時を指定したうえで検索してください。',
        ]),
      );
      return;
    }

    const limit = state.navi.limit;
    requestParams.first = limit;
    if (after) {
      requestParams.after = after;
    }

    Xhr.execute(
      'GET',
      API_URL,
      requestParams,
      (data) => {
        const eventlogs = data && data.eventlogs ? data.eventlogs : [];
        const nextCursor =
          eventlogs.length > 0 ? eventlogs[eventlogs.length - 1].ulid : null;
        const navi = {
          limit,
          after: nextCursor,
          history: history.slice(),
          canPrev: history.length > 0,
          canNext: Boolean(nextCursor && eventlogs.length === limit),
        };
        dispatch(receiveEventlogs(eventlogs, navi));
      },
      (xhr, status, err) => {
        dispatch(error(Xhr.getErrors(xhr)));
      },
    );
  };
};

export const receiveEventlogs = (eventlogs, navi) => {
  return {
    type: types.RECEIVE_EVENTLOGS,
    eventlogs,
    navi,
  };
};

export const receiveEventlog = (eventlog) => {
  return {
    type: types.RECEIVE_EVENTLOG,
    eventlog,
  };
};

export const setFilter = (filter) => {
  return {
    type: types.SET_FILTER,
    filter,
  };
};

export const searchEventlogs = (filter) => {
  return (dispatch) => {
    const normalized = normalizeFilter(filter);
    if (normalized.error) {
      dispatch(error([normalized.error]));
      return;
    }
    dispatch(setFilter(normalized.filter));
    dispatch(
      fetchEventlogsInternal({
        params: Object.assign({}, normalized.params),
        history: [],
      }),
    );
  };
};

export const nextPage = () => {
  return (dispatch, getState) => {
    const state = getState();
    if (!state.navi.canNext || !state.navi.after) return;
    const history = state.navi.history.concat([
      {
        eventlogs: state.eventlogs,
        after: state.navi.after,
      },
    ]);
    dispatch(
      fetchEventlogsInternal({
        after: state.navi.after,
        history,
      }),
    );
  };
};

export const prevPage = () => {
  return (dispatch, getState) => {
    const state = getState();
    if (!state.navi.canPrev || state.navi.history.length === 0) return;
    const history = state.navi.history.slice();
    const previous = history.pop();
    if (!previous) return;
    const navi = {
      limit: state.navi.limit,
      after: previous.after,
      history,
      canPrev: history.length > 0,
      canNext: Boolean(previous.after),
    };
    dispatch(receiveEventlogs(previous.eventlogs, navi));
  };
};

export const error = (errors, errorObj) => {
  return {
    type: types.ERROR,
    errors,
    errorObj,
  };
};

export const clearDetail = () => {
  return receiveEventlog(null);
};
